import nearestPointOnLine from '@turf/nearest-point-on-line';

import debug from 'utils/debug';

const { PROFILER } = debug('utils:nearest-point-on-line');

export default function find(line, point) {
  return PROFILER('find', () => nearestPointOnLine(line, point));
}
